import { render, staticRenderFns } from "./footprint.vue?vue&type=template&id=c534205e&"
import script from "./footprint.vue?vue&type=script&lang=js&"
export * from "./footprint.vue?vue&type=script&lang=js&"
import style0 from "./footprint.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports